import { useState, type FormEvent } from "react";
import { Link, useParams } from "react-router-dom";
import { ApiError, apiClient } from "../api/client";

export function InvitationAcceptPage() {
  const { token = "" } = useParams();
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function accept(event: FormEvent<HTMLFormElement>) {
    event.preventDefault(); const form = event.currentTarget; const data = new FormData(form);
    setBusy(true); setError("");
    try {
      await apiClient.acceptInvitation(token, String(data.get("password")), String(data.get("display_name")));
      setDone(true);
    } catch (reason) {
      setError(reason instanceof ApiError ? reason.message : "邀请接受失败");
    } finally { setBusy(false); }
  }

  return <main className="login-page"><div className="login-container">
    <div className="brand login-brand"><span className="brand-mark"><i /><i /><i /></span><span><strong>DeepVision</strong><small>团队邀请</small></span></div>
    {done ? <section className="login-card"><h1>已加入团队</h1><p className="muted">账号已创建，请登录后开始工作。</p><Link className="button primary wide" to="/login">去登录</Link></section> :
      <form className="login-card" onSubmit={(event) => void accept(event)}><h1>接受团队邀请</h1><p className="muted">设置显示名和首次登录密码。</p><label>显示名<input name="display_name" required /></label><label>设置密码<input name="password" type="password" minLength={12} autoComplete="new-password" required /></label>{error && <div className="inline-error" role="alert">{error}</div>}<button className="button primary wide" disabled={busy}>{busy ? "正在加入…" : "接受邀请"}</button></form>}
  </div></main>;
}
